import { Enum } from '../../../library';
export var OverlayStatusType = Enum({
  OPENING: 'opening',
  OPEN: 'open',
  CLOSING: 'closing',
  CLOSED: 'closed'
});